import axios from "axios";

export function getApiErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    return (
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Something went wrong."
    );
  }

  // Zod error (validation)
  if (error instanceof Error) {
    return error.message;
  }

  return "Something went wrong.";
}
